/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RiskPolicyBypassApprovalRequestBody = {
  /**
   * Principal URNs to grant bypass access to. Use user:all for every user in the organization.
   */
  grantedPrincipalUrns?: Array<string> | undefined;
  /**
   * The bypass request ID.
   */
  id: string;
};

/** @internal */
export type RiskPolicyBypassApprovalRequestBody$Outbound = {
  granted_principal_urns?: Array<string> | undefined;
  id: string;
};

/** @internal */
export const RiskPolicyBypassApprovalRequestBody$outboundSchema: z.ZodMiniType<
  RiskPolicyBypassApprovalRequestBody$Outbound,
  RiskPolicyBypassApprovalRequestBody
> = z.pipe(
  z.object({
    grantedPrincipalUrns: z.optional(z.array(z.string())),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      grantedPrincipalUrns: "granted_principal_urns",
    });
  }),
);

export function riskPolicyBypassApprovalRequestBodyToJSON(
  riskPolicyBypassApprovalRequestBody: RiskPolicyBypassApprovalRequestBody,
): string {
  return JSON.stringify(
    RiskPolicyBypassApprovalRequestBody$outboundSchema.parse(
      riskPolicyBypassApprovalRequestBody,
    ),
  );
}
